import ReactDOM from "react-dom";

import IComponent from "components/commons/IComponent";

import "./New3DListPanel.scoped.css";
import ItemCard from "./ItemCard";
import React, { Fragment } from "react";
import { Button } from "@material-ui/core";
import SwitchTabs from "components/commons/SwitchTabs";
import FilterPanel from "./FilterPanel";
import SlopeGroupCard from "./SlopeGroupCard";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import { Divider } from "@material-ui/core";
import LayerToggleUtil from "utils/LayerToggleUtil";

const GENERAL_RESULT = "General Result";
const UAV = "UAV";
const BIM_MODEL = "BIM Model";
const LANDSLIDE = "Landslide Incident";
const MMF = "Man-made Feature";
const THREE_D_GEOTECH = "3D Geotechnical Model";
const OTHERS = "Others";
const TUNNEL = "Tunnel";

const CATEGORY_GROUP_LIST = {
  locationList: "location",
  slopeNoList: "originSlopeNos",
};

const CATEGORY_GROUP_KEY = {
  [GENERAL_RESULT]: "locationList",
  [MMF]: "slopeNoList",
  [LANDSLIDE]: "locationList",
  [UAV]: "locationList",
  [THREE_D_GEOTECH]: "locationList",
  [BIM_MODEL]: "slopeNoList",
  [TUNNEL]: "locationList",
  [OTHERS]: "locationList",
};
let filter_list = [
  {
    title: "showOnList",
    titleText: "Show On List",
    type: "Radio",
    values: ["showAll", "showSelectedOnly"],
    valueText: ["Show All", "Show Selected Only"],
  },
  {
    title: "listBy",
    titleText: "Quick Filter",
    type: "MultiList",
    values: ["listBySlopeNumber", "listByLocation"],
    valueText: ["Slope Number", "Location"],
    listData: [
      //[{optionName:'', checked: false}]
      [],
      [],
    ],
  },
  // {
  //     title: "List by",
  //     type: "MultiChoice",
  //     values: ["3D Mesh Model", "Point Cloud Model"]
  // },
  // {
  //     title: "Landsilde Incident",
  //     type: "Radio",
  //     values: ["Show All", "Selected Date"]
  // },
];

let lastSlopeNameFilterOption = [];
let lastLocationFilterOption = [];

let lastListByRadioSelection = "";
let lastShowOnRadioSelection = "";

let currentCategorySlopeNames = {};

let currentCategorySlopeNameskeys = [];

class New3DListPanel extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: "card",
      currentAvailableCategry: [GENERAL_RESULT],
      currentCategry: GENERAL_RESULT,
      Layer3DSearchResult: this.updateSearchResult(props, false),
      filterKeyword: "",
      showFilterPanel: false,

      /** Filter UI Related */
      //control filter list
      beforeSave_radioGroup_showOnListValue:
        "showAll" /*|| "showSelectedOnly"*/,
      beforeSave_radioGroup_listByValue:
        /*"listByLocation"|| */ "listBySlopeNumber",
      disable_listByLocationRadioBtn: false,
      disable_listBySlopeNumberRadioBtn: false,
      show_listBySlopeNumberList: true,
      show_listByLocationList: false,
      /**End of Filter UI Related */

      // control group card
      radioGroup_showOnListValue: "showAll" /*|| "showSelectedOnly"*/,
      radioGroup_listByValue: /*"listByLocation"|| */ "listBySlopeNumber",
      filter_listBy: /*"location" ||*/ "slopeNo",
      filter_showOnList: "selectAll" /* || "onlySelected"*/,
      beforeSave_filter_showOnList: "selectAll" /* || "onlySelected"*/,
      beforeSave_filter_listBy: /*"location" ||*/ "slopeNo",

      filterOptions: {
        onListOption: "showAll",
        activeList: CATEGORY_GROUP_KEY[GENERAL_RESULT],
        locationList: undefined,
        slopeNoList: undefined,
      },
    };
  }
  componentDidMount() {}
  componentWillUnmount() {
    // for reset filter list data when close and open panel again
    filter_list[1].listData[0] = [];
    filter_list[1].listData[1] = [];
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.reduxStore.global.Layer3DSearchResult !==
      this.props.reduxStore.global.Layer3DSearchResult
    ) {
      this.updateSearchResult();
    }

    //list by filter (for render group card)
    if (
      prevState.radioGroup_listByValue !== this.state.radioGroup_listByValue
    ) {
      if (this.state.radioGroup_listByValue === "listBySlopeNumber") {
        this.setState({
          filter_listBy: "slopeNo",
        });
      } else if (this.state.radioGroup_listByValue === "listByLocation") {
        this.setState({
          filter_listBy: "location",
        });
      }
    }

    //list by filter (for render filter list setting)
    if (
      prevState.beforeSave_radioGroup_listByValue !==
      this.state.beforeSave_radioGroup_listByValue
    ) {
      if (
        this.state.beforeSave_radioGroup_listByValue === "listBySlopeNumber"
      ) {
        this.setState({
          beforeSave_filter_listBy: "slopeNo",
        });
      } else if (
        this.state.beforeSave_radioGroup_listByValue === "listByLocation"
      ) {
        this.setState({
          beforeSave_filter_listBy: "location",
        });
      }
    }

    //show on list filter
    if (
      prevState.radioGroup_showOnListValue !==
      this.state.radioGroup_showOnListValue
    ) {
      if (this.state.radioGroup_showOnListValue === "showAll") {
        this.setState({
          filter_showOnList: "selectAll",
        });
      } else if (this.state.radioGroup_showOnListValue === "showSelectedOnly") {
        this.setState({
          filter_showOnList: "onlySelected",
        });
      }
    }

    if (prevState.currentCategry !== this.state.currentCategry) {
      this.resetFilterSlopeNameList(currentCategorySlopeNameskeys);
    }
  }

  updateSearchResult(props, writeToState = true) {
    let Layer3DSearchResult =
      (props || this.props).reduxStore.global.Layer3DSearchResult || {};
    Layer3DSearchResult = { ...Layer3DSearchResult };
    Object.keys(Layer3DSearchResult).forEach((i) => {
      Layer3DSearchResult[i] = Layer3DSearchResult[i].map(
        (j) => this.$config.mapList.layer3D[i][j]
      );
    });
    if (writeToState) {
      this.setState({
        Layer3DSearchResult,
      });
      this.resetFilter();
    } else return Layer3DSearchResult;
  }

  renderTabs() {
    let categoryList = Object.keys(CATEGORY_GROUP_KEY);
    let searchResult = this.props.reduxStore.global.Layer3DSearchResult;
    if (!searchResult) return;
    categoryList = categoryList.reduce((p, c, i) => {
      if (c === GENERAL_RESULT || c in searchResult) p.push(c);
      return p;
    }, []);
    let tabArr = categoryList;
    return (
      <SwitchTabs
        tabText={tabArr}
        onSwitchTabCallback={this.handleSwitchTabs.bind(this, tabArr)}
        activedTab={0}
      />
    );
  }

  handleSwitchTabs(tabArr, e) {
    this.setState(
      {
        currentCategry: tabArr[e],
        showFilterPanel: false,
      },
      () => {
        let filterOptions = { ...this.state.filterOptions };
        filterOptions.activeList = CATEGORY_GROUP_KEY[tabArr[e]];
        filterOptions.locationList = undefined;
        filterOptions.slopeNoList = undefined;
        this.setState({ filterOptions });
        // this.setState({
        //   disable_listBySlopeNumberRadioBtn: true,
        //   disable_listByLocationRadioBtn: true,
        //   show_listBySlopeNumberList: false,
        //   show_listByLocationList: false,
        // });
        // let curCat = this.state.currentCategry;
        // let grpKey = CATEGORY_GROUP_KEY[this.state.currentCategry];

        // this.setState({
        //   disable_listByLocationRadioBtn: curCat!==GENERAL_RESULT && grpKey!=="listByLocation",
        //   disable_listBySlopeNumberRadioBtn:  curCat!==GENERAL_RESULT && grpKey!=="listBySlopeNumber",
        //   show_listBySlopeNumberList: true,
        //   beforeSave_radioGroup_listByValue: grpKey,
        //   radioGroup_listByValue: grpKey
        // });
      }
    );
  }

  getCurrentItemsOfCategry() {
    let itemsArrOfCategry = [];
    let { Layer3DSearchResult } = this.state;

    if (this.state.currentCategry === GENERAL_RESULT) {
      itemsArrOfCategry = Object.values(Layer3DSearchResult).flat();
      // console.log("CHECK", itemsArrOfCategry.length);
    } else if (
      typeof Layer3DSearchResult[this.state.currentCategry] !== "undefined"
    ) {
      itemsArrOfCategry = Layer3DSearchResult[this.state.currentCategry];
    }

    return itemsArrOfCategry; //[{title: 'xxx', 'id': 'xxx', 'thumbnail': 'xxx'}, ...]
  }

  getItemCategryMapIfGeneralResult() {
    let { Layer3DSearchResult } = this.state;
    let generalResultCategoryMap = null;
    generalResultCategoryMap = Object.keys(Layer3DSearchResult)
      .map((i) => Array(Layer3DSearchResult[i].length).fill(i))
      .flat();

    return generalResultCategoryMap; //['UAV', 'BIM MODEL', ...., 'UAV']
  }

  refreshCurrentSlopeNamesObjectOfCategry(
    forFilterListDisplay = false,
    filterCurrentListBy = "slopeNo"
  ) {
    console.log(
      "refreshCurrentSlopeNamesObjectOfCategry",
      forFilterListDisplay
    );
    // {
    // '11-nw-22': { 'items': [], 'categry': [] },
    //  '11-ne-23': { 'items': [], 'categry': [] },
    // 'others':
    //    ...
    //  } or
    // {
    // 'xx Road': { 'items': [], 'categry': [] },
    //  'xx Roda': { 'items': [], 'categry': [] },
    // 'others':
    //    ...
    //  }
    currentCategorySlopeNames = {};
    let currentItemsOfCategry = this.getCurrentItemsOfCategry();
    let generalResultCategoryMap = null;

    // let listByStateNameToBeUsed = forFilterListDisplay ? 'beforeSave_filter_listBy' : 'filter_listBy';

    if (this.state.currentCategry === GENERAL_RESULT) {
      generalResultCategoryMap = this.getItemCategryMapIfGeneralResult();
    }

    currentItemsOfCategry.forEach((item, index) => {
      let currentSlopeName = undefined;
      if (item.metaData) {
        let grpKey = undefined;
        if (this.state.currentCategry === GENERAL_RESULT)
          grpKey =
            CATEGORY_GROUP_LIST[
              CATEGORY_GROUP_KEY[generalResultCategoryMap[index]]
            ];
        else
          grpKey =
            CATEGORY_GROUP_LIST[CATEGORY_GROUP_KEY[this.state.currentCategry]];
        currentSlopeName = item.metaData[grpKey] || "Others";
      }

      let categryOfEachItem =
        this.state.currentCategry === GENERAL_RESULT
          ? generalResultCategoryMap[index]
          : this.state.currentCategry;

      if (Object.keys(currentCategorySlopeNames).includes(currentSlopeName)) {
        currentCategorySlopeNames[currentSlopeName].items.push(item);
        currentCategorySlopeNames[currentSlopeName].categry.push(
          categryOfEachItem
        );
      } else {
        currentCategorySlopeNames[currentSlopeName] = {};
        currentCategorySlopeNames[currentSlopeName].items = [item];
        currentCategorySlopeNames[currentSlopeName].categry = [
          categryOfEachItem,
        ];
      }
    });

    currentCategorySlopeNameskeys = Object.keys(currentCategorySlopeNames);
    currentCategorySlopeNameskeys.sort((a, b) => {
      let slopeA = parseInt(a.match(/(\d{1,2}).*?/)?.[0]);
      let slopeB = parseInt(b.match(/(\d{1,2}).*?/)?.[0]);

      if (isNaN(slopeA) || isNaN(slopeB)) return a < b ? -1 : a == b ? 0 : 1;

      let cmpResult = slopeA - slopeB;
      if (cmpResult != 0) return cmpResult;
      else return slopeA < slopeB ? -1 : a == b ? 0 : 1;
    });

    if (currentCategorySlopeNames.Others) {
      let indexOfOthers = currentCategorySlopeNameskeys.findIndex(
        (key) => key === "Others"
      );
      currentCategorySlopeNameskeys.splice(indexOfOthers, 1);
      currentCategorySlopeNameskeys.push("Others");
    }

    console.log(currentCategorySlopeNameskeys);
  }

  refreshLayer3DResultAndRenderSlopeCard(type) {
    let itemsArrOfCategry = this.getCurrentItemsOfCategry();
    this.refreshCurrentSlopeNamesObjectOfCategry();

    if (type === "SlopeGroupCard") {
      if (itemsArrOfCategry.length === 0)
        return (
          <div className="BlankPanel">
            There is no 3D data that match the search criteria. Please refine
            your search criteria and try again.
          </div>
        );
      else {
        // console.log(currentCategorySlopeNames);

        let slopeCardArr = currentCategorySlopeNameskeys.reduce(
          (p, slopeN, idx) => {
            // console.log('itemsArrOfCategry', currentCategorySlopeNames[slopeN]);
            currentCategorySlopeNames[slopeN].items = this.filterLayer(
              currentCategorySlopeNames[slopeN].items,
              this.state.filterKeyword
            );
            if (currentCategorySlopeNames[slopeN].items.length > 0)
              p.push(
                <SlopeGroupCard
                  zoomNow={
                    this.props.reduxStore.global.Layer3DSearchZoomTo1st &&
                    idx === 0
                  }
                  cardMode={this.state.cardMode}
                  showDialog={this.props.showDialog}
                  slopeName={slopeN}
                  itemsArrOfEachSlope={currentCategorySlopeNames[slopeN].items}
                  categry={this.state.currentCategry}
                  generalResultCategoryMap={
                    this.state.currentCategry === GENERAL_RESULT
                      ? currentCategorySlopeNames[slopeN].categry
                      : null
                  }
                  mapView={this.props.mapView}
                  on3DLayerChange={() => this.setState({})}
                />
              );
            return p;
          },
          []
        );
        if (slopeCardArr.length > 0) {
          return slopeCardArr;
        } else {
          return (
            <div className="BlankPanel">
              No 3D layer matches the filter. Please refine the filter or reset
              the filter and try again.
            </div>
          );
        }
      }
    } else if (type === "resultCount") {
      // if(this.state.filter){
      itemsArrOfCategry = this.filterLayer(
        itemsArrOfCategry,
        this.state.filterKeyword
      );
      // }
      return itemsArrOfCategry.length;
    } else if (type === "selectedCount") {
      itemsArrOfCategry = this.selectedCount(itemsArrOfCategry);
      return itemsArrOfCategry;
    }
  }

  resetFilterSlopeNameList(slopeNameArr) {
    let listBy = filter_list.find((obj) => obj.title === "listBy");
    if (listBy) {
      // slope name
      listBy.listData[0] = slopeNameArr.map((slopeName) => ({
        optionName: slopeName,
        checked: true,
      }));
      //location
      listBy.listData[1] = slopeNameArr.map((slopeName) => ({
        optionName: slopeName,
        checked: true,
      }));
    }
  }

  onListByRadioChange(e) {
    this.refreshCurrentSlopeNamesObjectOfCategry(true);
  }

  filterLayer(layerList, filterText) {
    let {
      onListOption,
      activeList,
      locationList,
      slopeNoList,
    } = this.state.filterOptions;

    // Quick search textbox
    let layerDataListToShow = layerList.filter(
      (layer) =>
        filterText == "" ||
        (layer.tags.some((i) => i.toLowerCase().indexOf(filterText) > -1) ||
          layer.title.toLowerCase().indexOf(filterText) > -1 ||
          (layer.metaData &&
            Object.values(layer.metaData || {}).some(
              (i) => `${i}`.toLowerCase().indexOf(filterText) > -1
            )))
    );

    // Filter By Select List
    if (!!locationList && !!slopeNoList) {
      let filterList = this.state.filterOptions[activeList];
      filterList = filterList.filter((i) => i.checked).map((i) => i.optionName);
      let isOtherSelected = filterList.indexOf("Others") > -1;
      layerDataListToShow = layerDataListToShow.filter((layer) => {
        return (
          filterList.indexOf(layer.metaData?.location) > -1 ||
          filterList.some((i) => (layer.metaData?.slopeNo || {})[i]) ||
          (isOtherSelected &&
            !layer.metaData?.location &&
            !layer.metaData?.slopeNo)
        );
      });
    }

    // Show All / Select Only
    if (onListOption === "showSelectedOnly") {
      layerDataListToShow = layerDataListToShow.filter((layerData) => {
        return "layer" in layerData && layerData?.layer?.visible;
      });
    }

    return layerDataListToShow;
  }

  selectedCount(layerDataListToShow) {
    layerDataListToShow = layerDataListToShow.filter((layerData) => {
      return "layer" in layerData && layerData?.layer?.visible;
    }).length;

    let total = Object.values(this.state.Layer3DSearchResult)
      .flat()
      .filter((layerData) => {
        return "layer" in layerData && layerData?.layer?.visible;
      }).length;
    return `${layerDataListToShow} ${
      this.state.currentCategry != "General Result" ? "(" + total + ")" : ""
    }`;
  }

  onClickFilterButton() {
    // this.backupFilterSetting();
    this.setState({ showFilterPanel: true });
  }

  backupFilterSetting() {
    lastSlopeNameFilterOption = [];
    lastLocationFilterOption = [];
    lastListByRadioSelection = "";
    lastShowOnRadioSelection = "";

    lastListByRadioSelection = this.state.radioGroup_listByValue;
    lastShowOnRadioSelection = this.state.radioGroup_showOnListValue;

    // backup slopename filter setting
    filter_list[1].listData[0].forEach((slopeNameOption) => {
      let tmpSlopeNameOption = {};
      tmpSlopeNameOption.optionName = slopeNameOption.optionName;
      tmpSlopeNameOption.checked = slopeNameOption.checked;
      lastSlopeNameFilterOption.push(tmpSlopeNameOption);
    });

    // backup location filter setting
    filter_list[1].listData[1].forEach((locationOption) => {
      let tmpLocationOption = {};
      tmpLocationOption.optionName = locationOption.optionName;
      tmpLocationOption.checked = locationOption.checked;
      lastLocationFilterOption.push(tmpLocationOption);
    });
  }

  restoreFilterSetting() {
    this.setState({
      beforeSave_radioGroup_listByValue: lastListByRadioSelection,
      beforeSave_radioGroup_showOnListValue: lastShowOnRadioSelection,
      beforeSave_filter_showOnList: lastShowOnRadioSelection,
    });

    // restore slopename filter setting
    filter_list[1].listData[0] = lastSlopeNameFilterOption;

    // restore location filter setting
    filter_list[1].listData[1] = lastLocationFilterOption;
  }

  cancelFilterPanel() {
    // this.restoreFilterSetting();
    this.setState({ showFilterPanel: false });
  }

  okFilterPanel(filterOptions) {
    // this.backupFilterSetting();
    this.setState({
      filterOptions,
      showFilterPanel: false,
    });
  }
  resetFilter(filterOptions) {
    this.okFilterPanel({
      locationList: undefined,
      slopeNoList: undefined,
      onListOption: "showAll",
      activeList: CATEGORY_GROUP_KEY[this.state.currentCategry],
    });
  }

  createSearchResultTab() {
    return (
      <div className="New3DListSearchTab">
        {/* Filter Panel */}
        {this.state.showFilterPanel && (
          <FilterPanel
            resetFilter={this.resetFilter.bind(this)}
            filterOptions={this.state.filterOptions}
            resultList={this.state.Layer3DSearchResult}
            currentCategory={this.state.currentCategry}
            filter_list={filter_list}
            currentCategorySlopeNameskeys={currentCategorySlopeNameskeys}
            currentCategorySlopeNames={currentCategorySlopeNames}
            cancelFilterPanel={this.cancelFilterPanel.bind(this)}
            okFilterPanel={this.okFilterPanel.bind(this)}
            refreshCurrentSlopeNamesObjectOfCategry={this.refreshCurrentSlopeNamesObjectOfCategry.bind(
              this
            )}
          />
        )}
        <div>
          {/** Search Panel Content **/}
          <div className="SearchPanelContent">
            <div className="EqualWidthChildren">
              <div className="text">
                <div>
                  <span>Result: </span>

                  <span>
                    {this.refreshLayer3DResultAndRenderSlopeCard("resultCount")}
                  </span>
                  {this.state.currentCategry != "General Result" && (
                    <span>
                      &nbsp;(
                      {
                        Object.values(this.state.Layer3DSearchResult).flat()
                          .length
                      }
                      )
                    </span>
                  )}
                </div>
                <div>
                  <span>Selected: </span>
                  <span>
                    {this.refreshLayer3DResultAndRenderSlopeCard(
                      "selectedCount"
                    )}
                  </span>
                </div>
              </div>
              <Button
                onClick={() => {
                  this.setState({
                    cardMode: "card",
                  });
                }}
                className="icn_card"
                style={{ marginRight: "-15px" }}
              />
              <Button
                onClick={() => {
                  this.setState({
                    cardMode: "table",
                  });
                }}
                className="icn_table"
              />
              {/* <div className="secondDiv"> */}
              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "filterKeyword",
                    dataType: "text",
                    hint: "Enter Keyword",
                  },
                  row: this.state,
                }}
                onChange={(a, v) =>
                  this.setState({
                    filterKeyword: v.toLowerCase(),
                    // filter: false,
                  })
                }
              />
              {/* </div> */}
              <Button
                classes={{ root: "actionBtn" }}
                variant="contained"
                onClick={() => {}}
                style={{ height: "57.5px" }}
              >
                <span className="icn_menu_search icon_s" onClick={() => {}} />
              </Button>
              <Button
                className="filterbutton WhiteBackground"
                variant="contained"
                onClick={this.onClickFilterButton.bind(this)}
              >
                {/* <span>Filter</span> */}
                <span className="icn_filter" />
              </Button>
            </div>
          </div>

          {/** Items Container**/}
          <div className="new3DListItemsContainer">
            <Divider className="divider" />
            <div className="singleSlopeGroupCard">
              {this.refreshLayer3DResultAndRenderSlopeCard("SlopeGroupCard")}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="new3DListPanelContainer">
        <div className="ListTitle">3D Map Layer</div>
        {/** Tabs  **/}
        {this.renderTabs()}
        {this.createSearchResultTab()}
      </div>
    );
  }
}

export default New3DListPanel;
